import { render, staticRenderFns } from "./BulkBandwidthLineImportModal.vue?vue&type=template&id=636f5564&scoped=true&"
import script from "./BulkBandwidthLineImportModal.vue?vue&type=script&lang=js&"
export * from "./BulkBandwidthLineImportModal.vue?vue&type=script&lang=js&"
import style0 from "./BulkBandwidthLineImportModal.vue?vue&type=style&index=0&id=636f5564&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "636f5564",
  null
  
)

export default component.exports